import MicIcon from '@mui/icons-material/Mic';
import {useTranslation} from "react-i18next";
import {IconButton} from '@mui/material';
import {observer} from 'mobx-react';
import {useEffect} from 'react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';

export const SpeechButton = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const sr = gStorage.speechRec;
	const rec = sr.recognizer;

	if (!rec || !props.rec || !props.rec.action || !gStorage.conn.user.speech_rec)
		return null;

	let disableContinuous = false;

	function startRecording() {
		// console.log('startRecording, begin', sr.isRecording);

		/* No multiple recordings */
		if (sr.isRecording) {
			console.error('Already recording!');
			rec.stop();
			return;
		}

		const lang = window.localStorage.getItem('language');
		if (!lang) {
			rec.lang = 'en';
		} else {
			rec.lang = lang;
		}

		// alert('continuous', props.rec.continuous);

		rec.continuous = props.rec.continuous;
		rec.interimResults = rec.continuous;

		// console.log('startRecording', lang, rec.continuous);
		// alert('startRecording, begin ' + sr.isRecording + ' ' + lang)

		rec.onresult = (ev) => {
			// console.log('ev', ev.resultIndex, ev.results.length);

			for (let i = ev.resultIndex; i < ev.results.length; i++) {
				if (ev.results[i].isFinal) {
					const rawcmd = ev.results[i][0].transcript.toLowerCase().trim();
					const trans = 'speech.' + rawcmd;
					const result = t(trans);

					// console.log('Result', trans, result);

					if (trans === result) {
						// console.log('SpeechButton: unknown command', ev.results[i][0].transcript);
						
						props.rec.action(rawcmd, props.rec);
					} else {
						props.rec.action(result, props.rec);
					}
				}
			}
		}

		rec.onerror = (ev) => {
			console.error(`Speech recognition error: ${ev.error}`);
			// setDisableContinuous(true);
			disableContinuous = true;
		}

		rec.onstart = () => {
			gStorage.speechRec.setIsRecording(true);
			// console.log('onStart');
		}

		rec.onend = () => {
			gStorage.speechRec.setIsRecording(false);

			// console.log('onEnd, continuous', props.rec.continuous, disableContinuous);

			if (props.rec.continuous && window.location.pathname === '/add' && !disableContinuous)
				rec.start();
		}

		// console.log('Starting');
		rec.start();
   
		if (!props.rec.continuous) {
			setTimeout(() => {
				if (gStorage.speechRec.isRecording) {
					// console.log('Stopping');
					rec.stop();
				}
			}, 3000);
		}
	}

	useEffect(() => {
		// console.log('constructor, continuous', props.rec.continuous);

		if (props.rec.continuous) {
			startRecording();
		}
		
		// return (() => {
		// 	console.log('destructor');
		// })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<IconButton 
		    size='small'
		    sx={{color: sr.isRecording ? 'lightgreen' : 'white'}}
		    onClick={() => {
			    disableContinuous = false; 
			    startRecording();
		    }}
		>
			<MicIcon />
		</IconButton>
	);
})
